// utils/RouteGuard.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUser } from "../context/UserContext";

const RouteGuard = ({ children, allowedRoles }) => {
  const { user, currentView } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Allow access if user is in the correct view mode, regardless of actual role
    const viewAllowed =
      (currentView === "company" && allowedRoles.includes("client")) ||
      (currentView === "owner" && allowedRoles.includes("partner"));

    if (user && !viewAllowed) {
      navigate("/notfound");
    }
  }, [user, allowedRoles, navigate, location, currentView]);

  return children;
};

export default RouteGuard;
